<template>
  <div class="row justify-content-center">
    <div class="col-md-6">
      <b-container>
        <h3 class="text-center" style="margin: 30px;">Crea USER</h3>
        <b-form @submit.prevent="onFormSubmit">
          <div v-show="!readonly">
            <b-input-group prepend="Company" append="Role" class="mb-4">
              <b-form-select aria-label="organization_store" class="mx-3" v-model="user.orgId" placeholder="store" :options="Organizations">
              </b-form-select>
              <b-form-select aria-label="role" class="mx-3" v-model="user.role" placeholder="ruolo" :options="Roles">
              </b-form-select>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="Nome e Cognome" size="7" class="mb-4">
              <b-form-input aria-label="first name" class="mx-3" v-model="user.name" placeholder="nome" :formatter="formatter" required></b-form-input>
              <b-form-input aria-label="last name" v-model="user.surname" placeholder="cognome" :formatter="formatter" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="email" size="7" class="mb-4">
              <b-form-input aria-label="email" type="email" class="ml-3" v-model="user.email" placeholder="email" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group prepend="Cellulare" class="mb-4">
              <b-form-input aria-label="prefix" class="mx-3" v-model="user.phone_prefix" placeholder="prefisso internazionale" style="max-width: 60px" required></b-form-input>
              <b-form-input aria-label="mobile nr" v-model="user.phone_nr" placeholder="nr cellulare" required></b-form-input>
            </b-input-group>
          </div>
            <div>
            <b-input-group prepend="Indirizzo" class="mb-4">
              <b-form-input type="text" aria-label="address" class="ml-3"  v-model="user.address" :formatter="formatter" required placeholder="(via, piazza, corso, ...)">
              </b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group class="mb-4">
              <b-form-input type="text" v-model="user.postal_code" style="width: 20%;" required  placeholder="CAP"></b-form-input>
              <b-form-input type="text" class="ml-3" v-model="user.city" :formatter="formatter" required style="width: 40%;" placeholder="Città"></b-form-input>
              <b-form-input type="text" class="ml-3" v-model="user.province" required style="width: 10%;" placeholder="Provincia (SIGLA)"></b-form-input>
              <b-form-input type="text" class="ml-3" v-model="user.country" style="width: 10%;" required  placeholder="Nazione (SIGLA)"></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-input-group append="CARD" class="mb-4">
              <b-form-select aria-label="doc_type" style="max-width: 25%" v-model="selectedDocType" :options="docTypes" placeholder="tipo documento" required>
                <option v-for="(text, value) in docTypes" 
                  :key="value"
                  :value="text">
                </option>
              </b-form-select>
              <b-form-input aria-label="id nr" class="ml-3" style="max-width: 30%" v-model="user.doc_nr" placeholder="N.ro doc." :formatter="capLetter" required></b-form-input>
              <b-form-input aria-label="card uid" class="mx-3" style="max-width: 25%" v-model="cardUid" placeholder="UID" :formatter="capLetter" required></b-form-input>
            </b-input-group>
          </div>
          <div>
            <b-button  type="submit" size="lg" class="btn btn-primary btn-block" style="max-width: 30%; margin: auto">SALVA</b-button>
          </div>
        </b-form>

        <!-- <b-modal ref="my-modal" centered hide-footer title="User Creato/Aggiornato">
          <div class="d-block text-center">
            <h3>User <strong>{{ user.fullName }}</strong> creato/aggiornato.
            </h3>
          </div>
          <b-button class="mt-2" variant="outline-success" block @click="hideModal">
            CHIUDI
          </b-button>
        </b-modal> -->
        <!-- Success/error Modal -->
        <b-modal ref="my-modal" centered hide-footer title="Utente REGISTRATO">
           <div class="d-block text-center">
              <h3>User <strong>{{ userFullName }}</strong> creato.
              <br />CONTINUA per registrare il suo cane
              </h3>
           </div>
           <b-button class="mt-3" variant="outline-success" block @click= "hideModal">CONTINUA</b-button>
           <b-button class="mt-2" variant="outline-warning" block @click="toggleModal">
              CHIUDI
           </b-button>
        </b-modal>
      </b-container>
    </div>
  </div>
</template>

<script>
  //const STRIPE_PUBLISHABLE_KEY = 'pk_test_jqg4igaWIqcMjvKloEyJLfrQ00y19avHFQ';
  import { db, firebaseApp   } from '../../firebase/config.js';
  import { cardData } from '../../interfaces/CardData';
  import { mapGetters, mapMutations } from 'vuex';
  
  export default {
    data() {
      return {
        //msgBox: '',
        readonly: true,
        user: {
          name: '',
          surname: '',
          displayName: '',
          fullName: '',
          email: '',
          phone_prefix: '',
          phone_nr: null,
          address: '',
          postal_code: '',
          city: '',
          province: '',
          country: '',
          doc_type: null,
          doc_nr: '',
          role: 3,
          orgId: '',
        },
        Roles: [0,1,2,3],
        Organizations: [
          {
            value: 'd37SloAGeFNnFkbWpHuq',
            text: 'Amici di TOBIA - via Sardegna 35 Milano'
          },
          {
            value: 'CzEm4jjUh1GSV5j0ZbfA',
            text: "Dog's Corner - P.zza dei Cappuccini 2-2/A"
          },
          {
            value: 'NJKGHVUjn7aaOlNZDjbx',
            text: 'DogMotics Tuscolana - via dell\'Aeroporto 61/63' 
          }
        ],
        userFullName: '',
        docTypes: [
          { value: null, text: 'Seleziona tipo documento' },
          { value: 'ci', text: 'Carta Identità'},
          { value: 'pat.', text: 'Patente' },
          { value: 'pass', text: 'Passaporto' },
        ],
        selectedDocType: null,
        /*error: {
          value: null,
          message: ''
        },
        success: {
          value: null,
          message: ''
        },*/
        card: cardData,
        cardUid: null
      }
    },
    created() {
      console.log('auth_user', this.auth_user.claims, this.auth_user.loggedIn, this.auth_user.data)
      this.user.orgId = this.auth_user.claims.orgId
      if(this.auth_user.claims.role > 0 || this.auth_user.claims.role == null) {
        this.readonly = true
        //this.user.orgId.prop(required: true)
      } else { 
        this.readonly = false
      }
      this.user.phone_prefix = this.auth_user.data.storeDefaults.phonePrefix
      this.user.city = this.auth_user.data.storeDefaults.city
      this.user.province = this.auth_user.data.storeDefaults.province
      this.user.country = this.auth_user.data.storeDefaults.country
    },
    methods: {
      formatter(value) {
        //return value.charAt(0).toUpperCase() + value.slice(1)
        return value
          .toLowerCase()
          .split(' ')
          .map(function(word) {
            return word[0].toUpperCase() + word.substr(1);
          })
          .join(' ');
      },
      capLetter(value) {
        return value.toUpperCase()
      },
      showModal() {
        this.$refs['my-modal'].show()
      },
      hideModal() {
        console.log('fase1 finita')
        this.$refs['my-modal'].hide()
        this.$router.push({name:'add_dog'})
        //this.$router.push({name:'user_detail'})
      },
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has been hidden
        this.$refs['my-modal'].toggle('#toggle-btn')
      },
      /*onCardSubmit() {
        if(!this.cardUid)
        {
          alert('Inserire Card UID')
          return
        }
        this.$refs.ddCard.hide()
      },*/
      cleanUpForm() {
        // clean up input field
        this.user.name = ''
        this.user.surname = ''
        this.user.email = ''
        this.user.phone_nr = ''
        this.user.address = ''
        this.user.postal_code = ''
        this.user.doc_type = ''
        this.user.doc_nr = ''
        this.card = cardData
        this.cardUid = ''
      },
      onFormSubmit(event) {
        event.preventDefault();
        this.user.displayName = this.user.name + ' ' + this.user.surname
        this.user.fullName = this.user.surname + ' ' + this.user.name
        this.user.doc_type = this.selectedDocType
        const setUser = firebaseApp
        .functions('europe-west3')
        .httpsCallable('setUser');

        setUser(this.user)
        .then((resp) => {
          //Save user data returned by API function on VUEX Store
          //console.log(resp.data.result);
          console.log(resp)
          console.log(resp.data.result.userId);
          console.log(resp.data.result.displayName);
          this.set_sel_user({
            id: resp.data.result.userId,
            fullName: resp.data.result.fullName,
            displayName: resp.data.result.displayName,
          });
          //Create new active Card with basic fields and with no subscription subsItem
          this.card = {
            uid: this.cardUid,
            data: {
              active: true, // to be activated after adding first subscription
              //userRef: this.sel_user.data.id, // string => userRef
              //displayName: this.sel_user.data.displayName,
              userRef: resp.data.result.userId,
              displayName: this.user.name + ' ' + this.user.surname.substring(0,1) + '.',
              //fullName: this.sel_user.data.fullName,
              fullName: this.sel_user.data.fullName.replaceAll("'", " "), //no ' can be saved on card
              orgId: this.user.orgId,
              role: this.user.role, // number => 1 || 2 (ie, Store Mgr, SELF Rent)
              subsItems: 0 // no subscription items for Admin USERs
            }
          };
          //Save card data on VUEX Store
          this.set_sel_card(this.card);

          console.log('card before creation ->', this.card.uid, this.card.data);
          db.collection('cards').doc(this.card.uid).set(this.card.data)
          .then(() => {
            //alert("CARD creata!");
            console.log('sel_card ->', this.sel_card);
            this.cleanUpForm();
            this.userFullName = this.sel_user.data.fullName
            this.userDisplayName = this.sel_user.data.displayName
            this.showModal();
          })
          .catch((error) => {
            console.log(error);
            alert(error.message)
          });
        })
        /*.then((resp) => {
          //Save user data returned by API function on VUEX Store
          //console.log(resp.data.result);
          console.log(resp.data.result.userId);
          console.log(resp.data.result.displayName);
          this.set_sel_user({
            id: resp.data.result.userId,
            fullName: resp.data.result.fullName,
            displayName: resp.data.result.displayName,
          });
          //Create new active Card with basic fields and with no subscription
          //NEW
          this.card = {
            uid: this.cardUid,
            data: {
              active: true, // to be activated after adding first subscription
              //userRef: this.sel_user.data.id, // string => userRef
              //displayName: this.sel_user.data.displayName,
              userRef: resp.data.result.userId,
              displayName: this.user.name + ' ' + this.user.surname.substring(0,1) + '.',
              fullName: this.sel_user.data.fullName,
              orgId: this.user.orgId,
              role: this.user.role, // number => 1 || 2 (ie, Store Mgr, SELF Rent)
              subsItems: 0 // no subscription items for Admin USERs
            }
          };
          //Save card data on VUEX Store
          this.set_sel_card(this.card);

          console.log('card before creation ->', this.card.uid, this.card.data);
          db.collection('cards').doc(this.card.uid).set(this.card.data)
          .then(() => {
            //alert("CARD creata!");
            console.log('sel_card ->', this.sel_card);
            this.cleanUpForm();
            this.userFullName = this.sel_user.data.fullName
            this.userDisplayName = this.sel_user.data.displayName
            this.showModal();
          })
          .catch((error) => {
            console.log(error);
            alert(error.message)
          });
        })*/
        .catch((err) => {
          //Display error
          console.log(err)
          alert(err.message)
        });
      },
      ...mapMutations({
        set_sel_user: 'SET_SEL_USER', // map `this.set_sel_user()` to `this.$store.commit('SET_SEL_USER')`
        set_sel_card: 'SET_SEL_CARD'
      })
    },
    computed: {
      ...mapGetters({
        // map `this.sel_**` to `this.$store.getters._**`
        sel_user: "_user",
        sel_card: "_card",
        // map `this.auth_user` to `this.$store.getters.user` (logged authenticated/authorized user)
        auth_user: "user",
      }),
    },
    mounted() {
      this.$root.$on('bv::modal::ok', (bvModalEvt) => {
        console.log('Modal closed', bvModalEvt)
      })
    }
  };
</script>

<style>
  .btn-primary {
    background: #bad300;
    border: #bad000;
  }
  .material-icons {
    font-size: 24px;
    margin-right: 10px;
    color: #ccc;
    cursor: pointer;
  }
  .material-icons:hover {
    color: #777;
  }
  .success {
    color: $success;
  }
</style>